import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { DatosSesion } from '../../Components/Common/DatosSesion';
import SoporteModal from './SoporteModal';
import './SoporteButton.css';

const SoporteButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  
  // Obtener datos del usuario logueado
  const userData = DatosSesion('debug');
  
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  
  // Detectar ruta actual
  const location = useLocation();
  
  // No mostrar el botón si no hay usuario logueado
  if (!userData || !userData.id) {
    return null;
  }
  
  // No mostrar el botón flotante en la página de soporte/tickets
  if (location.pathname.includes('/soporte/tickets')) {
    return null;
  }
  
  return (
    <>
      {/* Botón flotante de soporte */}
      <div className="soporte-button-fixed">
        <Button
          color="primary"
          className="soporte-button"
          onClick={handleOpenModal}
          title="Abrir ticket de soporte"
        >
          <i className="ri-headphone-line"></i>
          <span className="soporte-button-text">Soporte</span>
        </Button>
      </div>
      
      {/* Modal para crear ticket */}
      <SoporteModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        userData={userData}
      />
    </>
  );
};

export default SoporteButton;
